import { render, staticRenderFns } from "./provideImage.vue?vue&type=template&id=b73156b0&scoped=true&"
import script from "./provideImage.vue?vue&type=script&lang=js&"
export * from "./provideImage.vue?vue&type=script&lang=js&"
import style0 from "./provideImage.vue?vue&type=style&index=0&id=b73156b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73156b0",
  null
  
)

export default component.exports